<template>
  <div id="signedup">
    <div class="container">
      <div class="welcome">
        <div class="row-1">
          First, let’s find out your <span>Inner Traits</span>
        </div>
        <div class="row-2">
          <span>COSEC Assessment</span>
          <ul>
            <li>It takes 5~10 min to complete</li>
            <li>Follow your gut; don’t overthink</li>
            <li>You can change answer only once</li>
          </ul>
        </div>
        <div class="row-3">You will be able to see your result instantly.</div>
      </div>

      <div class="button-container">
        <div class="button" @click="moveToTestPage">Lets Start!</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../utils/common'

export default {
  name: 'Signedup',
  mixins: [common],
  created() {
    this.$parent.setNav(false)
    this.$parent.headerBack = true
    this.$parent.setHeader(this.pageTitle)
    this.$parent.setBottomTab(false)

    if (this.isEmpty(this.$store.state.auth.user)) {
      alert('Incorrect approach.')
      this.goBack()
    }
  },
  data() {
    return {
      pageTitle: 'Welcome to SUM!'
    }
  },
  methods: {
    moveToTestPage() {
      this.goPage('testquestions')
    }
  }
}
</script>

<style lang="scss" src="@/scss/acc.scss" scoped></style>
